export default "__VITE_ASSET__Bnam3tWI__"